import { useState, useCallback } from 'react';
import moment  from 'moment';
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import { ReadingReport } from './ReadingReport';
import { useMutation } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';


// 나의 독서이력?
export const UserReadingReport = () => {
    const [ stdate, setStdate ] = useState(moment().subtract(30, 'days').toDate());
    const [ eddate, setEddate ] = useState(moment().toDate());
    const [userReport, setUserReport] = useState(null);

    const reportMutate = useMutation({
        // mutationKey:['user/reading/report'],
        mutationFn:(data)=>Api.post('/api/user/reading/report', data),
        onSuccess:(res)=>{
            setUserReport(res.data);
        },
        onError:(err)=>{
            toast.error( createFetchErrorMessage(err).message );
        }
    })
    
    const onSearchReport = useCallback(() => {
        if(reportMutate.isPending)return;
        reportMutate.mutate({stdate, eddate});
    }, [stdate, eddate, reportMutate]);


    const onCancelReport = useCallback(() => {
        setUserReport(null);
    }, []);


    return (
            <>
                <div className="box print reading_history">
                    <div className="inner">
                        <h3><span className="icon11">나의 독서 이력 출력</span><i className="icon print fas fa-print"></i></h3>
                        <ul className="bullet_list _check">
                            <li>독서이력 기간 지정 후 조회를 하시면 내역을 프린트 할 수 있습니다.</li>
                        </ul>
                        <div className="select_date">
                            <div className="input_wrap">
                                <DatePicker selected={stdate} selectsStart onChange={(date) => setStdate(date)}
                                        startDate={stdate} endDate={eddate}
                                        closeOnScroll={true}
                                        dateFormat="yyyy-MM-dd" className="form-control" placeholderText="시작" />
                                    <span>~</span>
                                <DatePicker selected={eddate} selectsEnd onChange={(date) => setEddate(date)}
                                            startDate={stdate} endDate={eddate}
                                            closeOnScroll={true}
                                            dateFormat="yyyy-MM-dd" className="form-control" placeholderText="종료" />
                            </div>
                            <button type="button" className="btn _blue btn_submit" onClick={onSearchReport}>조회</button>
                            <button type="button" className="btn _red btn_cancel" onClick={onCancelReport}>취소</button>
                        </div>
                    </div>
                </div>

                <ReadingReport userReport={userReport} />
            </>
    );
};